import Fraction from './fractionClass';
export default class ComplexSpecial {
    constructor(n, r) {
        if (typeof r === "undefined") {
            r = new Fraction(1, 1);
        }
        else if (typeof r === "number") {
            r = new Fraction(r, 1);
        }
        this.r = r;
        //@ts-ignore
        Number.prototype.mod = function (n) {
            return ((this % n) + n) % n;
        };
        //@ts-ignore
        this.n = n.mod(24);
        const aArray = ["1", "pi/12", "\\sqrt{3}", "\\sqrt{2}", "", "5pi/12"];
        const bArray = ["0", "pi/12", "", "\\sqrt{2}", "\\sqrt{3}", "5pi/12"];
        const thetaArray = ["0", "\\frac{\\pi}{12}", "\\frac{\\pi}{6}", "\\frac{\\pi}{4}", "\\frac{\\pi}{3}", "\\frac{5\\pi}{12}", "\\frac{\\pi}{2}",
            "\\frac{7\\pi}{12}", "\\frac{2\\pi}{3}", "\\frac{3\\pi}{4}", "\\frac{5\\pi}{6}", "\\frac{11\\pi}{12}"];
        // assigning theta
        if (this.n < 12) {
            this.theta = thetaArray[this.n];
        }
        else if (this.n == 12) {
            this.theta = "\\pi ";
        }
        else {
            this.theta = "-" + thetaArray[12 - (this.n) % 12];
        }
        //assigning a, b, typesetString
        let a, b;
        if (this.n % 6 == 0) { // special cases with zero
            if (this.n == 0) {
                a = r.toString();
                b = "0";
                this.typesetString = a;
            }
            else if (this.n == 6) {
                a = "0";
                b = r.toString();
                let bString = "";
                if (b != "1") {
                    bString = b;
                }
                this.typesetString = bString + "i";
            }
            else if (this.n == 12) {
                a = r.multiply(-1).toString();
                b = "0";
                this.typesetString = a;
            }
            else if (this.n == 18) {
                a = "0";
                b = r.multiply(-1).toString();
                let bString = "-";
                if (b != "-1") {
                    bString = b;
                }
                this.typesetString = bString + "i";
            }
            else {
                this.typesetString = "error";
                a = "error";
                b = "error";
            }
            this.a = a;
            this.b = b;
        }
        else {
            let coeff = new Fraction(1, 2);
            coeff = coeff.multiply(r);
            if (this.n < 6) {
                let coeffStringA, coeffStringB;
                if (coeff.den == 1 && coeff.num == 1) {
                    if (aArray[this.n]) { // non-empty
                        coeffStringA = "";
                    }
                    else {
                        coeffStringA = coeff.toString();
                    }
                    coeffStringB = "";
                }
                else {
                    coeffStringA = coeff.toString();
                    coeffStringB = coeff.toString();
                }
                this.a = coeffStringA + aArray[this.n];
                this.b = coeffStringB + bArray[this.n];
                this.typesetString = this.a + "+" + this.b + "i";
            }
            else if (this.n < 12) {
                let coeffStringA, coeffStringB;
                if (coeff.den == 1 && coeff.num == 1) {
                    if (aArray[6 - (this.n % 6)]) { // non-empty
                        coeffStringA = "";
                    }
                    else {
                        coeffStringA = coeff.toString();
                    }
                    coeffStringB = "";
                }
                else {
                    coeffStringA = coeff.toString();
                    coeffStringB = coeff.toString();
                }
                this.a = "-" + coeffStringA + aArray[6 - (this.n % 6)];
                this.b = coeffStringB + bArray[6 - (this.n % 6)];
                this.typesetString = this.a + "+" + this.b + "i";
            }
            else if (this.n < 18) {
                let coeffStringA, coeffStringB;
                if (coeff.den == 1 && coeff.num == 1) {
                    if (aArray[this.n % 6]) { // non-empty
                        coeffStringA = "";
                    }
                    else {
                        coeffStringA = coeff.toString();
                    }
                    coeffStringB = "";
                }
                else {
                    coeffStringA = coeff.toString();
                    coeffStringB = coeff.toString();
                }
                this.a = "-" + coeffStringA + aArray[this.n % 6];
                this.b = "-" + coeffStringB + bArray[this.n % 6];
                this.typesetString = this.a + this.b + "i";
            }
            else {
                let coeffStringA, coeffStringB;
                if (coeff.den == 1 && coeff.num == 1) {
                    if (aArray[6 - (this.n % 6)]) { // non-empty
                        coeffStringA = "";
                    }
                    else {
                        coeffStringA = coeff.toString();
                    }
                    coeffStringB = "";
                }
                else {
                    coeffStringA = coeff.toString();
                    coeffStringB = coeff.toString();
                }
                this.a = coeffStringA + aArray[6 - (this.n % 6)];
                this.b = "-" + coeffStringB + bArray[6 - (this.n % 6)];
                this.typesetString = this.a + this.b + "i";
            }
        }
    }
    toString(cartesianMode = true) {
        if (cartesianMode) {
            return this.typesetString;
        }
        else {
            let rString = this.r.toString();
            if (this.r.num == 1 && this.r.den == 1) {
                rString = "";
            }
            return rString + "e^{" + this.theta + " i}";
        }
    }
    multiply(z) {
        const newR = this.r.multiply(z.r);
        const newN = (this.n + z.n) % 24;
        return new ComplexSpecial(newN, newR);
    }
    divide(z) {
        const newR = this.r.divide(z.r);
        const newN = (this.n - z.n) % 24;
        return new ComplexSpecial(newN, newR);
    }
    pow(n) {
        const newR = this.r.pow(n);
        const newN = (this.n * n) % 24;
        return new ComplexSpecial(newN, newR);
    }
    conjugate() {
        return new ComplexSpecial((24 - this.n) % 24, this.r);
    }
}
